import request from '@/utils/request'

// 获取系统设置
export function getSettings () {
  return request({
    url: '/settings',
    method: 'get'
  })
}

// 批量更新系统设置
export function saveSettings (data) {
  return request({
    url: '/settings',
    method: 'put',
    data
  })
}

// 修改密码
export const updatePassword = changePassword
export function changePassword (data) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data
  })
}

// 上传文件
export function uploadFile (formData) {
  return request({
    url: '/files/upload',
    method: 'post',
    data: formData
    // 移除手动的 headers 设置，让浏览器自动处理 Content-Type
  })
}
